export const AssetTypes = [
  {identifier: 'image', label: 'Image'},
  {identifier: 'video', label: 'Video'},
  {identifier: 'html', label: 'HTML'},
  {identifier: 'css', label: 'CSS'},
  {identifier: 'js', label: 'JS'},
];
